<template>
	<div id="GoTop" @click="GoTop()">
		<img src="@/assets/img/return-top.png" />
	</div>
</template>
<script>
	export default {
		name: "GoTop",
		data() {
			return {
				flag: false
			};
		},
		methods: {
			GoTop() {
				(function smoothscroll() {
					var currentScroll =
						document.documentElement.scrollTop || document.body.scrollTop;
					if (currentScroll > 0) {
						window.requestAnimationFrame(smoothscroll);
						window.scrollTo(0, currentScroll - currentScroll / 10);
					}
				})();
			}
		}
	};
</script>
<style scoped>
	#GoTop {
		position: fixed;
		right: 60px;
		bottom: 140px;
		z-index: 99999999;
		cursor: pointer;
	}
	@media (max-width:767px) {
		#GoTop {
			right: 20px;
			bottom: 40px;
		}
	}
	
	@media screen and (min-width: 768px) and (max-width: 1170px) {
		#GoTop {
			bottom: 80px;
		}
	}
	#GoTop>img {
		width: 60px;
		height: 60px;
	}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue